import app from 'flarum/forum/app';
export default async function ensureCommunityRewind(year, cancelled) {
  if (!app.session.user || !app.session.user.attribute('isEmailConfirmed') || !app.forum.attribute('rewindEnabled') || !app.forum.attribute('canViewRewind') || !app.forum.attribute('rewindAutoCommunity') || year !== app.forum.attribute('rewindActiveYear') || year > app.forum.attribute('rewindPreviousYear')) {
    return false;
  }
  while (!cancelled()) {
    const progress = await app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/rw-community/ensure',
      body: {
        year
      }
    });
    if (progress.ready) return !cancelled();
    await new Promise(resolve => setTimeout(resolve, progress.busy ? 1500 : 250));
  }
  return false;
}
flarum.reg.add('huseyinfiliz-rewind', 'forum/utils/ensureCommunityRewind', ensureCommunityRewind);